<template>
    <b-modal
        v-model="isShown"
        centered
        title="Add Currency"
        lazy
    >
        <Spinner v-if="loading" />
        <b-container
            v-else
            fluid
        >
            <b-row>
                <b-form-group class="w-100">
                    <div><label>Currency</label></div>
                    <Multiselect
                        v-model.trim="$v.currency.$model"
                        track-by="value"
                        label="label"
                        selected-label=""
                        :options="currencyOptions"
                    />
                    <b-form-invalid-feedback :force-show="$v.currency.$dirty && !$v.currency.required">
                        The currency is required.
                    </b-form-invalid-feedback>
                </b-form-group>
            </b-row>
            <b-row>
                <b-form-group
                    :description="lastUpdated"
                    class="mb-0 w-100"
                >
                    <div><label>Exchange Rate</label></div>
                    <b-form-input
                        v-model.trim="$v.exchangeRate.$model"
                        type="text"
                        @blur.native="formatExchangeRate"
                    />
                    <b-form-invalid-feedback :force-show="$v.exchangeRate.$dirty && !$v.exchangeRate.required">
                        The exchange rate is required.
                    </b-form-invalid-feedback>
                    <b-form-invalid-feedback :force-show="$v.exchangeRate.$dirty && !$v.exchangeRate.decimal">
                        The exchange rate must be a decimal value.
                    </b-form-invalid-feedback>
                </b-form-group>

            </b-row>
        </b-container>
        <div slot="modal-footer">
            <b-btn
                variant="default"
                class="mr-2"
                @click="reset()"
            >
                Close
            </b-btn>
            <Button
                variant="success"
                :disabled="loading || $v.$invalid"
                :loading="submitLoading"
                @click="handleSubmit()"
            >
                Add Currency
            </Button>
        </div>
    </b-modal>
</template>

<script>
import { required, decimal } from 'vuelidate/lib/validators';
import { formatFloat } from '@/utils/helpers';
import Multiselect from 'vue-multiselect';
import api from '../_api';

export default {

    components: {
        Multiselect,
    },

    data() {
        return {
            isShown: false,
            loading: false,
            submitLoading: false,
            currencyOptions: [],
            currency: {},
            exchangeRate: '1.0000',
        };
    },

    validations: {
        currency: {
            required,
        },
        exchangeRate: {
            required,
            decimal,
        },
    },

    watch: {
        currency() {
            this.exchangeRate = this.currency.exchange_rate;
        },
    },

    created() {
        this.$eventBus.$on(this.$events.openAddCurrencyModal, async () => {
            this.loading = true;
            this.isShown = true;
            const currencies = await api.getAvailableCurrencies(
                this.$store.getters['costable/costableType'], this.$store.getters['costable/costableId']
            );
            this.currencyOptions = Object.values(currencies);
            this.loading = false;
        });
    },

    computed: {
        lastUpdated() {
            if (this.currency.updated_at) {
                return `Last updated ${moment(new Date(this.currency.updated_at)).fromNow()}`;
            }
        },
    },

    methods: {
        async handleSubmit() {
            this.submitLoading = true;
            await this.$store.dispatch('costable/storeCurrency', {
                currencyId: this.currency.value,
                exchangeRate: this.exchangeRate,
            });
            this.submitLoading = false;
            this.reset();
        },
        formatExchangeRate() {
            this.exchangeRate = formatFloat(this.exchangeRate, 4);
        },
        reset() {
            this.isShown = false;
            this.currencyOptions = [];
            this.currency = {};
            this.exchangeRate = '1.0000';
            this.$nextTick(() => {
                this.$v.$reset();
            });
        },
    },

};
</script>
